module.exports = __webpack_public_path__ + "static/media/constructors_boba.ef80f2a5.png";